require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-can-a-biden-administration-strengthen-the-united.json") })
        }
      }, "path---en-us-update-how-can-a-biden-administration-strengthen-the-united");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-can-a-biden-administration-strengthen-the-united!./.cache/json/en-us-update-how-can-a-biden-administration-strengthen-the-united.json
// module id = 678
// module chunks = 231608221292675